import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../resource/kgvl1.png";
import { IoReorderThreeOutline } from "react-icons/io5";
import { FaChevronDown } from "react-icons/fa";
import Vector from "../resource/Vector.png";

export const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isBookingDropdownOpen, setBookingDropdownOpen] = useState(false);
  const [isMobileBookingDropdownOpen, setMobileBookingDropdownOpen] =
    useState(false);

  const dropdownRef = useRef(null);
  const location = useLocation();

  const isProductPage = ['/OrderKgvHelmet', '/KgvkitOrder', '/KgvbikeOrder'].includes(location.pathname);

  const handleBookNowClick = () => {
    let targetId = '';
    if (location.pathname === '/OrderKgvHelmet' || location.pathname === '/KgvbikeOrder') {
      targetId = 'complete-your-order';
    } else if (location.pathname === '/KgvkitOrder') {
      targetId = 'build-your-perfect-kit';
    }
    
    if (targetId) {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setMobileMenuOpen(false);
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setBookingDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="sticky top-0 z-50 w-full bg-white shadow-lg">
      <div className="flex items-center justify-between max-w-[1240px] mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Logo */}
        <div className="flex items-center h-[72px] w-[72px] py-2">
          <Link to="/" className="h-full w-full">
            <img src={logo} alt="Logo" className="h-full w-full object-contain" />
          </Link>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex font-inter gap-10 items-center text-lg">

          <Link to="/" className="hover:border-b-2 hover:border-[#ecf662]">
            Home
          </Link>

          {/* Bikes Dropdown */}
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setBookingDropdownOpen(!isBookingDropdownOpen)}
              className="py-2 flex items-center hover:border-b-2 hover:border-[#ecf662]"
            >
              Products <FaChevronDown className="ml-1" />
            </button>

            {isBookingDropdownOpen && (
              <div className="absolute left-0 mt-2 bg-white text-green-700 rounded-md shadow-lg w-60">
                <Link
                  to="/booking"
                  className="block px-4 py-2 hover:bg-gray-200 whitespace-nowrap"
                >
                  ⚡ Prebook Hybrid Bike
                </Link>

                <Link
                  to="/KgvbikeOrder"
                  className="block px-4 py-2 hover:bg-gray-200 whitespace-nowrap"
                >
                  🏍️ Buy KGV BIKE
                </Link>

                <Link
                  to="/KgvkitOrder"
                  className="block px-4 py-2 hover:bg-gray-200 whitespace-nowrap"
                >
                  🔖 Buy KGV KIT
                </Link>
             <Link
  to="/OrderKgvHelmet"
  className="block px-4 py-2 hover:bg-gray-200 whitespace-nowrap"
>
  🎯KGV Helmet
</Link>

                <Link
                  to="/rentkgvbike"
                  className="block px-4 py-2 hover:bg-gray-200 whitespace-nowrap"
                >
                  📃 Rent KGV BIKE
                </Link>
              </div>
            )}
          </div>

          <Link to="/distribution" className="hover:border-b-2 hover:border-[#ecf662]">
            Distribution
          </Link>

          <Link to="/event" className="hover:border-b-2 hover:border-[#ecf662]">
            Events
          </Link>

          <Link to="/about" className="hover:border-b-2 hover:border-[#ecf662]">
            About Us
          </Link>

          <Link to="/contactUs" className="hover:border-b-2 hover:border-[#ecf662]">
            Contact Us
          </Link>
        </div>

        {/* Desktop Book Now / Prebook Hybrid */}
        {isProductPage ? (
          <button
            onClick={handleBookNowClick}
            className="hidden md:flex items-center gap-2 bg-green-600 hover:bg-green-700 px-4 py-2 text-white font-bold rounded-xl"
          >
            Book Now
            <img src={Vector} className="h-4 w-4" alt="" />
          </button>
        ) : (
          <Link
            to="/booking"
            className="hidden md:flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 px-4 py-2 text-white font-bold rounded-xl shadow-md hover:shadow-lg transition-all"
          >
            Prebook Hybrid
          </Link>
        )}

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}>
            <IoReorderThreeOutline size={32} color="black" />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white text-black flex flex-col items-center py-3 gap-2">

          <Link to="/" onClick={() => setMobileMenuOpen(false)} className="py-2">
            Home
          </Link>

          {/* Bikes Mobile Dropdown */}
          <button
            onClick={() =>
              setMobileBookingDropdownOpen(!isMobileBookingDropdownOpen)
            }
            className="flex items-center justify-center gap-2 py-2"
          >
            Products <FaChevronDown />
          </button>

           {isMobileBookingDropdownOpen && (
            <div className="w-full bg-gray-200 rounded-md flex flex-col">
              <Link
                to="/booking"
                onClick={() => setMobileMenuOpen(false)}
                className="px-6 py-2 hover:bg-gray-300 whitespace-nowrap"
              >
                ⚡ Prebook Hybrid Bike
              </Link>

              <Link
                to="/KgvbikeOrder"
                onClick={() => setMobileMenuOpen(false)}
                className="px-6 py-2 hover:bg-gray-300 whitespace-nowrap"
              >
                🏍️ Buy KGV BIKE
              </Link>

              <Link
                to="/KgvkitOrder"
                onClick={() => setMobileMenuOpen(false)}
                className="px-6 py-2 hover:bg-gray-300 whitespace-nowrap"
              >
                🔖 Buy KGV KIT
              </Link>
               <Link
  to="/OrderKgvHelmet"
  onClick={() => setMobileMenuOpen(false)}
    className="px-6 py-2 hover:bg-gray-300 whitespace-nowrap"
>
    🎯  KGV Helmet
</Link>

              <Link
                to="/rentkgvbike"
                onClick={() => setMobileMenuOpen(false)}
                className="px-6 py-2 hover:bg-gray-300 whitespace-nowrap"
              >
                📃 Rent KGV BIKE
              </Link>
            </div>
          )}

          <Link to="/distribution" onClick={() => setMobileMenuOpen(false)} className="py-2">
            Distribution
          </Link>

          <Link to="/event" onClick={() => setMobileMenuOpen(false)} className="py-2">
            Events
          </Link>

          <Link to="/about" onClick={() => setMobileMenuOpen(false)} className="py-2">
            About Us
          </Link>

          <Link to="/contactUs" onClick={() => setMobileMenuOpen(false)} className="py-2">
            Contact Us
          </Link>

          {/* Mobile Book Now / Prebook Hybrid */}
          {isProductPage ? (
            <button
              onClick={handleBookNowClick}
              className="mt-4 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg flex items-center gap-2"
            >
              Book Now
              <img src={Vector} className="h-4 w-4" alt="" />
            </button>
          ) : (
            <Link
              to="/booking"
              onClick={() => setMobileMenuOpen(false)}
              className="mt-4 bg-emerald-600 hover:bg-emerald-700 text-white px-5 py-2.5 rounded-lg flex items-center gap-2 font-bold shadow-md shadow-emerald-600/20"
            >
              Prebook Hybrid
            </Link>
          )}
        </div>
      )}
    </div>
  );
};
